<form nz-form [formGroup]="newsletterForm" (ngSubmit)="submit()" class="flex items-start max-w-96">
  <nz-form-item class="!mb-0 flex-1">
    <nz-form-control nzErrorTip="Please enter a valid email!">
      <input nz-input type="email" formControlName="email" placeholder="Enter your email"
        [ngClass]="TextSizeMap.p.md.important"
        class="lg:h-12 max-lg:h-10 !rounded-r-none rounded-l-lg !px-4 !border-none" />
    </nz-form-control>
  </nz-form-item>
  <button ngText="p.md" nz-button nzType="primary" [nzLoading]="isAPICallSent()"
    class="shrink-0 !px-4 lg:h-12 max-lg:h-10 !rounded-l-none rounded-r-lg !border-l-0 bg-primary-500 hover:bg-primary-500/60 !border-none">
    Subscribe
  </button>
</form>